import Button from 'antd/es/button';
import Card from 'antd/es/card';
import Typography from 'antd/es/typography';
import { styled } from 'styled-components';

const { Text } = Typography;

export const UploadContainer = styled.div`
  ${({ theme }) => `
  margin: ${theme.marginLG}px 0;
`}
`;

export const StatusContainer = styled.div`
  ${({ theme }) => `
  text-align: center;
  padding: ${theme.paddingXL}px;
`}
`;

export const OptionCard = styled(Card)<{ $selected?: boolean }>`
  ${({ theme, $selected }) => `
  margin-bottom: ${theme.marginMD}px;
  cursor: pointer;
  transition: all ${theme.motionDurationMid} ${theme.motionEaseInOut};
  border-color: ${$selected ? theme.colorPrimary : theme.colorBorder};
  background: ${$selected ? theme.colorPrimaryBg : theme.colorBgContainer};
  
  &:hover {
    border-color: ${theme.colorPrimary};
    box-shadow: ${theme.boxShadowSecondary};
  }
`}
`;

export const FileDisplayContainer = styled.div`
  text-align: center;
`;

export const FileIcon = styled.div`
  ${({ theme }) => `
  font-size: ${theme.fontSizeHeading1 + 10}px;
  color: ${theme.colorSuccess};
  margin-bottom: ${theme.marginXS}px;
`}
`;

export const FileName = styled(Text)`
  ${({ theme }) => `
  font-size: ${theme.fontSizeLG}px;
  display: block;
  margin-bottom: ${theme.marginXXS}px;
`}
`;

export const FileSize = styled(Text)`
  ${({ theme }) => `
  color: ${theme.colorTextSecondary};
  display: block;
  margin-bottom: ${theme.marginXXS}px;
`}
`;

export const RemoveButton = styled(Button)`
  ${({ theme }) => `
  margin-top: ${theme.marginXXS}px;
`}
`;

export const FormActions = styled.div`
  ${({ theme }) => `
  margin-top: ${theme.marginLG}px;
  text-align: right;
`}
`;

export const ActionButton = styled(Button)`
  ${({ theme }) => `
  margin-left: ${theme.marginXS}px;
`}
`;
